import { Alert, Button, Card, Table, Modal, Accordion, Form, Container } from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper,Stycke,StyckeCompact} from "../ContentStyles";
import useBackend, {XLogOff, IsLoggedIn,Loading, Check, CallAPI, CallAPIGet} from '../../services/useBackend';
import {MaterialReactTable} from 'material-react-table';
import React, { useState ,useEffect, useReducer, fetchData,useMemo} from 'react';
import {DateTimeToLocal, MultiselectGetOptions, MultiselectGetDefaultValues, escapedNewLineToLineBreakTag, ConcatLocalDateAndTime2ISO, SplitoutLocalDateFromISO, SplitoutLocalTimeFromISO, getOptions, metaLookUpTitle, metaLookUpAccountTitle} from '../../services/misc';
import { FileUploader } from "react-drag-drop-files";
import axios from 'axios';

function Documents() {    
  const {loading, data, Refresh} =  useBackend(process.env.PUBLIC_URL+'/api/v1/upload/listUnTiedDocuments');
  const {loading:loadingmeta, data:metadata} =  useBackend(process.env.PUBLIC_URL+'/api/meta');   
  
  const [resultVariant, setResultVariant] = useState('warning');
  const [resultText,    setResultText]    = useState('N/A');
  const [resultVisible, setResultVisible] = useState(false);
  const [uploadText,    setUploadText]    = useState('N/A..');

  const [editModalshow, setEditModalshow] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState({Id:0, Guid:'00000000-0000-0000-0000-000000000000'});
  const fileTypes = ["pdf"];

  const editDocumentHandler = async (event, rowData)  =>  {
    setEditModalshow(true);
    setSelectedDocument(rowData.original);
  }

  var typingTimeout = null;

  async function handleChange(event){
    clearTimeout(typingTimeout);
    typingTimeout = setTimeout(handleSave, 475);
  }

  async function handleSave(){
    setResultText("");
    setResultVisible(false);
    const VerificationForm = document.getElementById('FrmDocumentEdit');
    const formData = new FormData(VerificationForm);
    const formDataObj = Object.fromEntries(formData.entries());

    formDataObj.BookKeepingVerificationId = parseInt(formDataObj.BookKeepingVerificationId, 10);
      
    let {resultVariant, resultVisible, resultText, errorsException, jsondata} = await CallAPI('/api/v1/upload/'+selectedDocument.Guid,"PATCH",JSON.stringify(formDataObj));
    if (resultVariant!="success") {
        setResultVariant(resultVariant);   
        setResultText(resultText);
        setResultVisible(resultVisible);
    }
  } 

  const submitAttachment = (selectedFile) => {
      const formData = new FormData();
      formData.append("file", selectedFile);

      axios
      .post("/api/v1/upload/00000000-0000-0000-0000-000000000000", formData, {headers: {'AccessToken': localStorage.getItem('access_token')}} )
      .then((res) => {
          setUploadText("Filen laddades upp");
          Refresh();
      })
      .catch((err) => {setUploadText("Något gick fel"); });
  };

  const columns = useMemo(() => [    
      { size: 30, accessorKey: 'comment',   header: 'comment', enableColumnActions: false },        
      { size: 30, accessorKey: 'created',   header: 'created', enableColumnActions: false },        
      { size: 30, accessorKey: 'fileName',  header: 'fileName', enableColumnActions: false },        
      { size: 30, accessorKey: 'fileext',   header: 'fileext', enableColumnActions: false },        
    ]
  );

  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 50 });

  const initialState = { density: 'compact', columnVisibility: { } };      

  const state = { pagination };     

  if (!loadingmeta) {
    return (
      <ContentWrapper>

        <Modal show={editModalshow} onHide={()=> {setEditModalshow(false); Refresh();}}>
            <Modal.Header closeButton>
                <Modal.Title>Ändra</Modal.Title>                            
            </Modal.Header>                            
            <Modal.Body>
                <Form id="FrmDocumentEdit">

                    <Form.Group className="mb-3">                                                                
                        <Form.Label>VerificationId</Form.Label>
                        <Form.Control type="text" name="BookKeepingVerificationId" id="BookKeepingVerificationId" placeholder="VerificationId" defaultValue={selectedDocument.BookKeepingVerificationId} onChange={handleChange} />

                        <Form.Label>Beskrivning</Form.Label>
                        <Form.Control as="textarea" rows="3" type="text" name="comment" id="comment" placeholder="Beskrivning" defaultValue={selectedDocument.comment} onChange={handleChange} />

                        {selectedDocument.Guid != '00000000-0000-0000-0000-000000000000' && <span style={{float:"left", margin:"8px"}}><img src={"/api/v1/upload/"+selectedDocument.Guid+"/thumbnail"} /></span>}
                    </Form.Group>                      
                </Form>                             

            </Modal.Body>

            <Modal.Footer>
                <Button variant="danger" onClick={()=>{ setEditModalshow(false); CallAPI('/api/v1/upload/'+selectedDocument.Guid, 'DELETE'); Refresh();}}>Ta bort</Button> 
                <Button variant="danger" onClick={()=>{setEditModalshow(false); Refresh();}}>Stäng</Button>                            
            </Modal.Footer>                            
        </Modal>
        
        <Sida>
          <MaterialReactTable columns={columns} data={data.fileList} state={state} initialState={initialState}
              muiTablePaginationProps={{ showFirstButton: false, showLastButton: false, rowsPerPageOptions: [25, 50, 75, 100] ,labelRowsPerPage:"Rader"}}
              renderTopToolbarCustomActions={() => (<span>Saldo</span>)}               

              muiTablePaperProps={{elevation: 0, sx: {borderRadius: '0',border: '0px dashed #e0e0e0'} }} 
              muiTableBodyRowProps={({ row }) => ({
              onClick: (event) => {editDocumentHandler(event, row);},sx: {cursor: 'pointer'},})}
          /> 
          <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert>         
        
          <Form>
              <span style={{float:"left", margin:"8px", height:"500px"}}>
                  <FileUploader id="Uploader" submitForm="" handleChange={submitAttachment} name="file"  label="" uploadedLabel={uploadText} multiple={false} maxSize={5} className="UploadBox"  />
                  <Form.Label>Tillåtna filtyper: {fileTypes.map((ft) => {return <>{ft} </>} )}</Form.Label>
              </span>
          </Form>
        </Sida>
      </ContentWrapper>        
    );
  } else {
      return (<Loading />);        
  }    
}

export default Documents;